export default __webpack_public_path__ + "static/2154-28e32eb57034722868dd01d69b7d09f2.gif";